{
  "version": 1,
  "asset_id": "d24d162f-0868-40c3-9875-8038dd1c96b7",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/d24d162f-0868-40c3-9875-8038dd1c96b7/STI_Produktvideo-hq.webm",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/d24d162f-0868-40c3-9875-8038dd1c96b7/STI_Produktvideo-hq.webm",
  "original_filename": "STI_Produktvideo-hq.webm",
  "size": 7156475,
  "content_type": "video/webm",
  "created_at": "2026-09-28T07:34:52Z"
}
